import { TRootState }                                   from 'Redux/Reducers';
import { filterObjectStore, queryFilter, IFilterProps } from 'Utils';
import { Location }                                        from 'Domain/Models';

export const getLocations = (state: TRootState, filter: null | IFilterProps<Location> = null) => {
  if (filter === null) {
    filter = queryFilter({ sorting: { by: 'address', order: 'ASC' } }) as IFilterProps<Location>;
  }

  return filterObjectStore(state.location.entries, filter);
};
